import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.reseller.add-new-company', {
        url: '/add-new-company',
        component: 'companyResellerAddNewCompany',
        resolve: {}
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reseller/add-new-company/add-new-company.state.js